import { MiFooter } from "../../components/footer/MiFooter";
import Header from "../../components/headers/Header";
import { ContentPresupuestos } from '../../components/Presupuestos/ContentPresupuestos';
import React, { useState } from 'react';
import { UsuarioContext } from '../../contexts/UsuarioContext';
import './HistorialFacuturas.css'
import { ContentHistorialFacturas } from "../../components/HistorialFacturas/ContentHistorialFacturas";

export const HistorialFacuturas = () => {

  const [MenuLateralAux, setMenuLateralAux] = useState(false);


  const chageMenuLateralAux = () => {
    setMenuLateralAux(!MenuLateralAux)
  }
  return (
    <div className="HistorialFacturas" >
      <div className="headerHistorialFacturas">
        <Header chageMenuLateralAux={chageMenuLateralAux} />
      </div>
      <div className="bodyHistorialFacturas">
        <ContentHistorialFacturas 
          MenuLateralAux={MenuLateralAux}
          chageMenuLateralAux={chageMenuLateralAux}
        />
      </div>
      <div className="footerHistorialFacturas">
        <MiFooter />
      </div>
    </div>
  )
}
